// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"8b127f24","966":"8b127f24"}[chunkId] + ".chunk.css";
};